/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { factoryT, fields } from 'factory-t';
import {
    Cashback,
    CashbackStatuses,
    EDVGERIAL_INFO_STATUSES_TYPES,
    EdvgerialInfo,
    TaxFreeInfo,
} from './cashbackClient.typings';

export const cashbackFactory = factoryT<Cashback>({
    returnRequestTransactionId: '2350',
    returnReturnTransactionId: '2349',
    returnStatus: CashbackStatuses.RETURNED,
    returnedAmount: 200,
    returnedDate: '2020-01-09T11:27:11.996063',
});

export const edvgerialInfoFactory = factoryT<EdvgerialInfo>({
    fiscalId: '5uezSTNUUjDMBH5UMfe4QZSK8tG9pTXWEQsXiocnWYhs',
    fin: '7er78bv',
    accountId: 'ibar',
    channel: 'Leo Bank',
    buyAmount: 500,
    returnedAmount: 50,
    returnedAmountCash: 10,
    returnedAmountCashless: 0,
    status: fields.sequence([...EDVGERIAL_INFO_STATUSES_TYPES]),
    statusDate: '2024-09-09T20:59:59.000Z',
    cancelCode: '40480',
    cancelMessage: 'Example cancel message',
    cancelDate: '2024-09-09T20:59:59.000Z',
    dvxStateCode: '222',
    dvxStateMessage: 'Example dvx message',
    dvxStateDate: '2024-09-09T20:59:59.000Z',
    refunded: true,
});

export const taxFreeInfoInfoFactory = factoryT<TaxFreeInfo>({
    fiscalId: '5uezSTNUUjDMBH5UMfe4QZSK8tG9pTXWEQsXiocnWYhs',
    invoiceSerial: 'TR',
    invoiceNumber: '2000019',
    name: 'ANZHELIKA',
    surname: 'SELEZNEVA',
    country: 'RUS',
    address: 'Example address',
    passportNumber: '736922123',
    objectType: 'Magaza',
    operationTime: '2024-09-09T20:59:59.000Z',
    operatorFin: '61NSQSR',
    totalAmount: 500,
    customsRefund: 50,
    bankRefund: 5,
    refundType: 'nagd',
    customsGate: 'Example custom location',
});
